import React from 'react';

import { t } from '../../services/i18nService';
import navigationService from '../../services/NavigationService';
import sessionReader from '../../store/readHelpers/SessionReader';
import OptionsTopBar from './OptionsTopBar';
import Confirmation from './Confirmation';

import styles from './options.scss';

class OptionsResumePassword extends React.PureComponent {
    actionHandler = () => {
        navigationService.resumedTestAfterPassword();
    };

    render() {
        const mainButtonText = t('options.resumeSebButtonText');
        const requireInvigilatorPassword = sessionReader.testUsesInvigilatorPassword();

        return (
            <div>
                <OptionsTopBar title={t('options.resumeSeb')} showOptionsButton showExitButton={false} />
                <div className={styles.mainContentArea} role="main">
                    <Confirmation
                        mainButtonText={mainButtonText}
                        actionHandler={this.actionHandler}
                        requireInvigilatorPassword={requireInvigilatorPassword}
                    />
                </div>
            </div>
        );
    }
}

export default OptionsResumePassword;
